import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { composeApp } from '@/bootstrap';
import { App } from '@/ui/App';
import { ErrorBoundary } from '@/ui/ErrorBoundary';

// The visual system. Imported at the root so the tokens exist before the first paint —
// a panel that renders before its variables are defined flashes unstyled. Fonts first, so the
// faces the tokens name are already declared when the tokens are read.
import '@/ui/fonts.css';
import '@/ui/theme.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('EduSketch: mount target #root is missing from index.html');
}

const wiring = composeApp();

createRoot(container).render(
  <StrictMode>
    {/*
      Inside StrictMode, outside App: a boundary that wrapped nothing but its own subtree
      would be unable to replace the shell it is meant to replace.
    */}
    <ErrorBoundary
      snapshot={() => wiring.file.snapshot()}
      onError={(error) => {
        console.error('EduSketch crashed', error);
      }}
    >
      <App
        controller={wiring.controller}
        store={wiring.store}
        tools={wiring.tools}
        file={wiring.file}
        drawFromProblem={wiring.drawFromProblem}
        accountApi={wiring.accountApi}
        reportApi={wiring.reportApi}
        onRendererReady={wiring.onRendererReady}
        initialFit={wiring.initialFit}
      />
    </ErrorBoundary>
  </StrictMode>
);
